import React from "react";
import CommonModal from "../../../../components/Common/CommonModal";
import CommonButton from "../../../../components/buttons/CommonButton";
import CommonInput from "../../../../components/forms/CommonInput";
import {
  handleChange,
  handleChangeFile,
  handleChangeNameValue,
} from "../../../../helpers/handleFormChanges";
import CommonSelect from "../../../../components/forms/CommonSelect";
import CommonInputFile from "../../../../components/forms/CommonInputFile";
import CommonInputValor from "../../../../components/forms/CommonInputValor";
import CommonInputDate from "../../../../components/forms/CommonInputDate";
import PropTypes from "prop-types";
import useTipos from "../../../../hooks/common/useTipos";

function NovaFolhaPagamentoModal({
  modalHook,
  valuesHook,
  colaboradores,
  salvaFolhaPagamento,
  anoInicial,
  anoFinal,
}) {
  const { novaFolhaPagamentoModal, setNovaFolhaPagamentoModal } = modalHook;
  const { values, setValues } = valuesHook;
  const tiposFolhaPagamento = useTipos("tipos_folha_pagamento");

  return (
    <CommonModal
      title="Nova folha de pagamento"
      is_open_modal={novaFolhaPagamentoModal}
      set_is_open_modal={setNovaFolhaPagamentoModal}
      size="xl"
      buttons={
        <CommonButton
          key={`upload-folha-pagamento`}
          color="success"
          onClick={() => {
            salvaFolhaPagamento();
          }}
        >
          Upload
        </CommonButton>
      }
    >
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonSelect
            label="Nome do colaborador"
            id="colaborador"
            value={values.colaborador}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={
              colaboradores &&
              Object.keys(colaboradores).map((colaborador) => ({
                text: colaboradores[colaborador].nome,
                id: colaboradores[colaborador].uid,
              }))
            }
            placeholder="Selecione o colaborador"
            required
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonSelect
            label="Tipo de verba"
            id="verba"
            value={values.verba}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={tiposFolhaPagamento.map((folhaPagamento) => ({
              text: folhaPagamento.valor,
              id: folhaPagamento.chave,
            }))}
            placeholder="Selecione o tipo"
            required
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInput
            label="Mês de referência"
            id="mesReferencia"
            value={values.mesReferencia}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            type="month"
            required
            min={`${anoInicial}-01`}
            max={`${anoFinal}-12`}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-4 mb-3">
          <CommonInputDate
            label="Pagamento"
            id="pagamento"
            value={values.pagamento}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInputValor
            label="Valor líquido"
            id="valor"
            value={values.valor}
            onChange={(e) => {
              handleChangeNameValue("valor", e.target.value, values, setValues);
            }}
            required
            tag={null}
          />
        </div>
        <div className="col-lg-4 mb-3">
          <CommonInputFile
            label="Selecione o arquivo"
            id="arquivo"
            onChange={(e) => handleChangeFile(e, values, setValues)}
            accept="application/pdf"
            required
          />
        </div>
      </div>
    </CommonModal>
  );
}

NovaFolhaPagamentoModal.propTypes = {
  modalHook: PropTypes.shape({
    novaFolhaPagamentoModal: PropTypes.bool.isRequired,
    setNovaFolhaPagamentoModal: PropTypes.func.isRequired,
  }).isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  colaboradores: PropTypes.object.isRequired,
  salvaFolhaPagamento: PropTypes.func.isRequired,
  anoInicial: PropTypes.number.isRequired,
  anoFinal: PropTypes.number.isRequired,
};

export default NovaFolhaPagamentoModal;
